export default __webpack_public_path__ + "static/optical-adjustment-do-2d190422cc38d7076247b0d94994f1d643cc60d20db9850b33d565366b9ef276.png";